import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MarketplaceItem,
  TransactionSuccessService,
  TransactionSuccessQuery,
  ProcessProviderId,
  PurchaseQuery,
  MemberPurchase,
  MemberQuery,
  MarketplaceExtendedQuery,
  AttributeValue,
  PurchaseCustomField,
  MarketplaceService,
} from '@fgb/core';
import { combineLatest, firstValueFrom } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-marketplace-purchase-success-page',
  templateUrl: './marketplace-purchase-success-page.component.html',
  styleUrls: ['./marketplace-purchase-success-page.component.scss'],
})
export class MarketplacePurchaseSuccessPageComponent implements OnInit, OnDestroy {
  purchasedItemList: MarketplaceItem[];
  price: number;
  quantity: number;
  theme = '';
  attributes: AttributeValue[];
  customFields: PurchaseCustomField[];
  purchasedItemLogId: number;
  ProcessProvider = ProcessProviderId;
  populations = Populations;
  isEventItem: boolean;
  private destroyRef = inject(DestroyRef);

  constructor(
    private transactionSuccessQuery: TransactionSuccessQuery,
    private transactionSuccessService: TransactionSuccessService,
    private purchaseQuery: PurchaseQuery,
    private memberQuery: MemberQuery,
    private marketplaceExtendedQuery: MarketplaceExtendedQuery,
    private marketplaceService: MarketplaceService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
    const storeValue = this.transactionSuccessQuery.getValue();
    this.purchasedItemList = [storeValue.item as MarketplaceItem];
    this.quantity = storeValue.quantity;
    this.price = storeValue.totalPrice;
    this.theme = this.purchasedItemList[0].theme;
    const processProviderId = this.purchasedItemList[0]?.ProcessProviderId;
    this.isEventItem = processProviderId === ProcessProviderId.Event || processProviderId === ProcessProviderId.VirtualEvent;

    combineLatest([this.purchaseQuery.selectPurchases(), this.memberQuery.userContext$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([purchases, userContext]) => {
        const orderedPurchases = purchases.filter((p) => p.OrderId === storeValue.orderId);
        const uniquePurchases: MemberPurchase[] = [];
        orderedPurchases.forEach((element) => {
          if (!uniquePurchases.some((p) => p.RewardItemId === element.RewardItemId)) {
            uniquePurchases.push(element);
            this.purchasedItemLogId = element.LogId;
          }
        });

        if (uniquePurchases[0]?.AttributeValues && userContext?.lcid) {
          this.attributes = this.marketplaceExtendedQuery.getLocalisedAttributeValuesFromArray(
            uniquePurchases[0].AttributeValues,
            +userContext.lcid
          );
        }
        if (uniquePurchases[0]) {
          this.customFields = uniquePurchases[0].CustomFields;
        }
      });
  }

  downloadPurchasedItem(logId: number) {
    firstValueFrom(this.marketplaceService.downloadMarketplaceItem(logId)).then((response) => {
      const newBlob = new Blob([response], { type: response.type });
      const anchor = window.document.createElement('a');
      anchor.href = window.URL.createObjectURL(newBlob);
      anchor.download = logId.toString();
      document.body.appendChild(anchor);
      anchor.click();
      window.URL.revokeObjectURL(anchor.href);
      document.body.removeChild(anchor);
    });
  }

  ngOnDestroy() {
    this.transactionSuccessService.clear();
    this.navigationService.showMobileNav();
  }
}
